import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface ModalAlertProps { 
    show: boolean; 
    didPressOk: () => void; 
    messageTitle: string;
    messageText: string;
}

export default class ModalAlert extends React.Component<ModalAlertProps> {
    render(){
        return (
            <Modal show={this.props.show} onHide={this.props.didPressOk}>
                <Modal.Header>
                    <Modal.Title>{this.props.messageTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.props.messageText}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.props.didPressOk}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}